import { useNavigation } from 'react-router';

import { useIsNavigatingAway } from '@jane/bloom/hooks/navigation/useIsNavigatingAway';

/**
 * @param {RegExp} pathPattern - Regex pattern to test pending navigation route against
 * @returns {boolean} whether the page is navigating to a location matching input regex
 */
export const useIsNavigatingTo = (pathPattern: RegExp): boolean => {
  const { location: destinationLocation } = useNavigation();
  const isNavigatingAway = useIsNavigatingAway();
  return Boolean(
    isNavigatingAway && destinationLocation?.pathname.match(pathPattern)
  );
};
